import { buildRolePermissions, getRolesFromOidcUser, RolePermissions } from '_lib/auth/rbac';
import { useMemo } from 'react';
import { useAuth } from 'react-oidc-context';

export const useRolePermissions = (): RolePermissions => {
  const { user } = useAuth();

  return useMemo(() => {
    const roles = getRolesFromOidcUser(
      user ? { profile: user.profile, accessToken: user.access_token } : undefined,
    );
    return buildRolePermissions(roles);
  }, [user]);
};

export default useRolePermissions;
